import { Button } from '@crazyegginc/hatch';

import { useAuthContext, usePermissions } from '/src/hooks';
import { SupportLinks } from '/src/support';
import { Paywall } from '/src/components/Paywall';
import { FEATURES } from '/src/features/_global/constants';

import ExpiredPNG from '@crazyegginc/hatch/dist/images/illustration-cc-expired.png';
import ExpiredWebP from '@crazyegginc/hatch/dist/images/illustration-cc-expired.webp';
import { AppLink } from '/src/features/_global/components/AppLink';

export function SubscriptionExpiredPaywall() {
  const { currentAccount } = useAuthContext();
  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;

  return (
    <Paywall>
      <Paywall.Image webp={ExpiredWebP} fallback={ExpiredPNG} width="143" />
      <Paywall.Title>Your Crazy Egg subscription has expired</Paywall.Title>
      {canManageBilling ? (
        <>
          <Paywall.Body>
            Your subscription expired because we tried to charge your credit card, but the payment didn&#39;t go
            through. To continue using Crazy Egg, please reactivate your subscription and update your billing
            information.
          </Paywall.Body>
          <Button component={AppLink} to={`/account/billing`}>
            Update credit card
          </Button>
        </>
      ) : (
        <>
          <Paywall.Body>
            To continue using Crazy Egg, contact your Account Owner &#40;{currentAccount.ownerEmail}&#41; to reactivate
            this subscription.
            <div className="mt-5">
              If you need help, email us at{' '}
              <a className="text-link" href={`mailto:${SupportLinks.general.email}`}>
                {SupportLinks.general.email}
              </a>
              .
            </div>
          </Paywall.Body>
          <Button component="a" href={`mailto:${currentAccount.ownerEmail}`}>
            Contact account owner
          </Button>
        </>
      )}
    </Paywall>
  );
}
